import { render, staticRenderFns } from "./DeviceSimulator.vue?vue&type=template&id=c58ae2c2"
import script from "./DeviceSimulator.vue?vue&type=script&lang=js"
export * from "./DeviceSimulator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports